import homeImage from '../images/home.png';
import '../styles/frontPageContent.scss'
import { FrontPageLabels } from '../constants/constants';
import { useSelector } from 'react-redux';
import { Fade } from 'react-reveal';

const FrontPageContent = () => {

    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);

    return (
    <div className = "front-page-content">
        <Fade bottom><img className = "front-page-content__image" src = {homeImage}/></Fade>
        <Fade top><div className = "front-page-content__title">{FrontPageLabels.labels.title[currentLanguage]}</div></Fade>
    </div>
    )
}

export default FrontPageContent